import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import StudentLayout from 'src/layouts/student';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const DashboardPage = lazy(() => import('src/pages/student/dashboard'));
const CoursesPage = lazy(() => import('src/pages/student/courses'));
const CourseDetailsPage = lazy(() => import('src/pages/student/course-details'));
const LessonPage = lazy(() => import('src/pages/student/lesson'));
const SavedPage = lazy(() => import('src/pages/student/saved'));
const ProfilePage = lazy(() => import('src/pages/student/profile'));

// ----------------------------------------------------------------------

export const studentRoutes = [
    {
        path: 'student/:shopid',
        element: (
            <AuthGuard userType="subscriber">
                <StudentLayout>
                    <Suspense fallback={<SplashScreen />}>
                        <Outlet />
                    </Suspense>
                </StudentLayout>
            </AuthGuard>
        ),
        children: [
            { element: <DashboardPage />, index: true },
            { path: 'dashboard', element: <DashboardPage /> },
            { path: 'courses', element: <CoursesPage /> },
            { path: 'course/:id', element: <CourseDetailsPage /> },
            { path: 'course/:courseId/lesson/:lessonId', element: <LessonPage /> },
            { path: 'saved', element: <SavedPage /> },
            { path: 'profile', element: <ProfilePage /> },
        ],
    },
];
